import { createStore, Store, useStore as baseUseStore } from 'vuex';
import utilityModule from './modules/utility';
import campaignModule from './modules/campaign';
import globalModule from './modules/global';
import editingModule from './modules/editing';
import clipboardModule from './modules/clipboard';
import repeatableModule from './modules/repeatable';
import gamestepsModule from './modules/gamesteps';
import { RootState } from '@/store/state';
import { InjectionKey } from 'vue';
import { NamespacedGetters as campaignGetters } from '@/store/modules/campaign/getters';
import { NamespacedGetters as clipboardGetters } from '@/store/modules/clipboard/getters';
import { NamespacedGetters as editingGetters } from '@/store/modules/editing/getters';
import { NamespacedGetters as globalGetters } from '@/store/modules/global/getters';
import { NamespacedGetters as repeatableGetters } from '@/store/modules/repeatable/getters';
import { NamespacedGetters as utilityGetters } from '@/store/modules/utility/getters';
import { NamespacedGetters as gamestepsGetters } from '@/store/modules/gamesteps/getters';

/**
 * We are using namespaced modules in vuex -> See documentation here: https://next.vuex.vuejs.org/guide/modules.html#accessing-global-assets-in-namespaced-modules
 /**
 * -> getters['utility/getterName']
 * -> actions dispatch('utility/actionName')
 * -> mutations commit('utility/methodName')
 */

export const key: InjectionKey<Store<RootState>> = Symbol();

declare class TypedStore<S> extends Store<S> {
  readonly getters: campaignGetters &
    clipboardGetters &
    editingGetters &
    globalGetters &
    repeatableGetters &
    utilityGetters &
    gamestepsGetters;
}

export default createStore<RootState>({
  // Initial state is created by the modules
  state: {} as RootState,

  modules: {
    utility: utilityModule,
    campaign: campaignModule,
    global: globalModule,
    editing: editingModule,
    clipboard: clipboardModule,
    repeatable: repeatableModule,
    gamesteps: gamestepsModule
  }
}) as TypedStore<RootState>;

export const useStore = () => {
  return baseUseStore<RootState>(key) as TypedStore<RootState>;
};
